import * as L from "leaflet";
import { MapShortcut } from "./map-shortcut";

export class MapShortcutBars{
	evenramps: Array<MapShortcut> = [
		{name:'Ramp2', pos: new L.LatLng(38.17380379192546, -85.7314682006836)},
		{name:'Ramp4', pos: new L.LatLng(38.170936052293236, -85.73043823242188)},
		{name:'Ramp6', pos: new L.LatLng(38.169316573002256, -85.7297945022583)}
	  ];
	oddramps: Array<MapShortcut> = [
		{name:'Ramp1', pos: new L.LatLng(38.17618224330661, -85.73934316635132)},
		{name:'Ramp3', pos: new L.LatLng(38.173584498173376, -85.73878526687622)},
		{name:'Ramp5', pos: new L.LatLng(38.170699880471076, -85.73801279067993)},
		{name:'Ramp7', pos: new L.LatLng(38.16776453825026, -85.73709011077881)},
		{name:'Ramp9', pos: new L.LatLng(38.16344565894175, -85.73301315307617)},
		{name:'Ramp11', pos: new L.LatLng(38.16081371639859, -85.73588848114014)},
		{name:'Ramp21', pos: new L.LatLng(38.18691944, -85.75360833)},
		{name:'Ramp23', pos: new L.LatLng(38.1665800000000000, -85.7452900000000000)}
	  ];
	others: Array<MapShortcut> = [
		{name:'ASC', pos: new L.LatLng(38.16608172410148, -85.72927415370941)},
		{name:'Hanger', pos: new L.LatLng(38.16070405006412, -85.72832465171814)},
		{name:'Ramps', pos: new L.LatLng(38.16965396748852, -85.73404312133789)}
	  ];
	wings: Array<MapShortcut> = [
		{name:'WingA', pos: new L.LatLng(38.16626308187997, -85.7366394996643)},
		{name:'WingB', pos: new L.LatLng(38.16909726574871, -85.73715448379517)},
		{name:'WingC', pos: new L.LatLng(38.17201568516335, -85.73801279067993)},
		{name:'WingD', pos: new L.LatLng(38.17501832998918, -85.73899984359741)},
		{name:'WingE', pos: new L.LatLng(38.172622971624826, -85.73127508163452)},
		{name:'WingH', pos: new L.LatLng(38.16351314339866, -85.72741270065308)}
	  ];
}